import React from 'react';

import DropdownSelector from './dropdown-selector';
import { ArgumentItem } from '../../types/selection-item';

export interface ArgumentSelectorProps {
  argumentList: ArgumentItem[];
  onArgumentSelected: Function;
  selectedArgument?: ArgumentItem;
}

export const ArgumentSelector: React.FC<ArgumentSelectorProps> = (props) => {
  const className = `argument--${
    props.selectedArgument === undefined ? 'select' : 'selected'
  }`;

  const onClick = (item: ArgumentItem) => {
    props.onArgumentSelected(item);
  };

  React.useEffect(() => {
    if (props.argumentList.length > 0) {
      props.argumentList.sort((a, b) => {
        if (a.description && b.description) {
          if (a.description < b.description) return -1;
          if (a.description > b.description) return 1;
        }
        return 0;
      });
    }
  }, [props.argumentList]);

  return (
    <DropdownSelector<ArgumentItem, 'title'>
      fieldName={'title'}
      items={props.argumentList}
      onClick={(e) => onClick(e)}
      additionalClassname={className}
      selected={props.selectedArgument?.title}
    />
  );
};
